'use strict';
import {merge} from 'helpers/merge';
import {validation} from 'helpers/validation';
import Analytics from 'helpers/analytics/analytics';

export var Input = {
  defaultOptions: {
    validators: [validation.create(function(value) {
      return value !== '';
    })],
    errorNode: null,
    onClear: function() {},
    onValid: function() {},
    onInvalid: function() {},
    onCorrection: function() {},
    onIncomplete: function() {}
  },

  validatable: function(element, options) {
    var BACKSPACE = 8;
    var DELETE = 46;

    if(element === undefined) {
      throw new Error('The element provided was empty');
    }
    options = merge(options, this.defaultOptions);

    var validatableField = {
      focus: function() {
        element.focus();
      },
      removeClass: function(currentClass) {
        element.classList.remove(currentClass);
      },

      replace: function(currentClass, newClass) {
        validatableField.removeClass(currentClass);
        element.classList.add(newClass);
      },

      showErrorMessage: function() {
        if(element.nextSibling) {
          element.parentNode.insertBefore(options.errorNode, element.nextSibling);
        } else {
          element.parentNode.appendChild(options.errorNode);
        }

        if(options.errorNode) {
          Analytics.addError(options.errorNode.innerHTML);
        }
      },

      addAnalyticsError: function(errorText) {
        if (!errorText && options.errorNode) {
          errorText = options.errorNode.innerHTML;
        }
        Analytics.addError(errorText);
      },

      hideErrorMessage: function() {
        if (element.parentNode === options.errorNode.parentNode) {
          element.parentNode.removeChild(options.errorNode);
        }
      }
    };

    var incompleteMessage = element.getAttribute('data-incomplete-message');
    var requiresCorrection = false;
    if (options.errorNode) {
      options.errorNode.appendChild(document.createTextNode(incompleteMessage));
    }

    function validate(text) {
      var validCallback = isValid(text) ? options.onValid : options.onInvalid;
      validCallback(validatableField); // Determine which function to call, then call it.
    }

    ['cut', 'copy', 'paste'].forEach(function(action){
      element.addEventListener(action, function(event) {
        validate(event.clipboardData.getData('Text'));
      })
    });

    element.addEventListener('keyup', function(event) {
      if (event.keyCode === BACKSPACE || event.keyCode === DELETE) {
        validate(element.value);
      }

      if (element.value === '') {
        options.onClear(validatableField);
      } else {
        if (requiresCorrection) {
          options.onCorrection(validatableField);
          requiresCorrection = false;
        }

        validate(element.value);
      }
    });

    element.addEventListener('blur', function() {
      if(element.value === '') {
        return;
      }
      (isValid(element.value) ? options.onValid : options.onIncomplete)(validatableField);
    });

    function isValid(text) {
      var valid = true;
      for (var i = 0; i < options.validators.length; i++) {
        valid =  options.validators[i].test(text) && valid;
      }

      return valid;
    }

    return {
      validateSubmission: function(form) {
        if (!isValid(element.value)) {
          requiresCorrection = true;
          options.onIncomplete(validatableField);
          form.stop(validatableField);
          return false;
        } else {
          return true;
        }
      },
      showErrorMessage: validatableField.showErrorMessage,
      hideErrorMessage: validatableField.hideErrorMessage,
      getValidationElement: () => element,
      getFocusElement: () => element
    };
  }
};
